export const removeAccountsFromGroupBulkActionType = 'removeAccountsFromGroup';
